<template>
  <GenericModal
    :unique-id="`AdvGiftChoiceModalV2`"
    :ref="'AdvGiftChoiceGenericModal'"
    :has-header="true"
    :has-footer="true"
    :close-btn-color="'#ef1b1b'"
    :width="'780px'"
    :max-height="'620px'"
  >
    <div slot="header" class="">
      <h5 class="" id="">{{ t('modal.title', { namespace: 'giftSelection' }) }}</h5>
      <span class="">{{ t('modal.subtitle', { namespace: 'giftSelection' }) }}</span>
    </div>

    <div slot="default" class="">
      <adv-cart-gift-list :enable-picker="true"
                          :styling-options="stylingOptions"
                          :gift-choices-filter="filterGiftsWithChoice"></adv-cart-gift-list>
    </div>

    <div slot="footer" class="">
      <button type="button" class="btn btn-secondary"
              @click="$refs.AdvGiftChoiceGenericModal.closeModal()">{{
          t('modal.action.cancel', { namespace: 'giftSelection' }) }}</button>
      <button type="button" class="submit-btn" @click="confirmCheckout">{{
          t('modal.action.submit', { namespace: 'giftSelection' }) }}</button>
    </div>
  </GenericModal>
</template>

<script>
import AdvCartGiftList from './AdvCartGiftList'
import giftChoiceMixin from './mixins/giftChoiceMixin'
import GenericModal from '../../main/vue/presentation/GenericModal'
export default {
  name: 'AdvGiftChoiceModalV2',
  components: {
    AdvCartGiftList,
    GenericModal
  },
  mixins: [giftChoiceMixin],
  props: {
    identity: {
      type: String,
      required: false,
      default: 'GiftChoiceModal'
    },
    formSubmitHandle: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      stylingOptions: {
        items: 'col-12'
      }
    }
  },
  computed: {
    submitButton: function () {
      const submitButtonNodes = document.getElementsByName(this.formSubmitHandle)
      if (submitButtonNodes.length < 1) {
        throw new Error(
          `Unable to find form submit button using handle '${this.formSubmitHandle}'.` +
          'Possible causes: ' +
          'Prop form-submit-handle was supplied with invalid value; Submit button isn\'t rendered; Form isn\'t rendered'
        )
      }
      return submitButtonNodes[0]
    },
    submissionForm: function () {
      return this.submitButton.form
    }
  },
  methods: {
    confirmCheckout: function () {
      this.submitButton.click()
    }
  }
}
</script>
